import { customElement } from 'aurelia-templating';
import { bindable } from 'aurelia-typed-observable-plugin';

@customElement('global-linear-progress')
export class GlobalLinearProgress {
  @bindable.number
  progress: number;
}
